
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request/[workspaceId]/[requestId]",
      function () {
        return require("private-next-pages/request/[workspaceId]/[requestId]/index.tsx");
      }
    ]);
  